import { NgModule } from '@angular/core';
import { BdcWalkModule } from 'bdc-walkthrough';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { DialogService } from 'primeng/dynamicdialog';
import { SpeedDialModule } from 'primeng/speeddial';

import { AppSidebarComponent } from 'presentation/app-sidebar/app-sidebar.component';
import { SidebarAddExistingCoacheeComponent } from 'presentation/app-sidebar/sidebar-add-existing-coachee/sidebar-add-existing-coachee.component';
import { CoachingPlanModule } from 'presentation/app-sidebar/sidebar-coaching-plan/coaching-plan.module';

import { AppSharedModule } from '../../app-shared.module';
import { SidebarAddCoacheeComponent } from './sidebar-add-coachee/sidebar-add-coachee.component';
import { CoacheesEditObserversComponent } from './sidebar-coachees/coachees-edit-observers/coachees-edit-observers.component';
import { SidebarCoacheesComponent } from './sidebar-coachees/sidebar-coachees.component';
import { SidebarNotificationComponent } from './sidebar-notification/sidebar-notification.component';

@NgModule({
	declarations: [
		SidebarNotificationComponent,
		SidebarCoacheesComponent,
		SidebarAddExistingCoacheeComponent,
		SidebarAddCoacheeComponent,
		CoacheesEditObserversComponent,
		AppSidebarComponent,
	],
	imports: [
		BdcWalkModule,
		AppSharedModule,
		CoachingPlanModule,
		NgScrollbarModule,
		SpeedDialModule,
	],
	exports: [
		NgScrollbarModule,
		CoachingPlanModule,
		AppSidebarComponent,
		SidebarNotificationComponent,
		SidebarAddExistingCoacheeComponent,
		SidebarCoacheesComponent,
		SidebarAddCoacheeComponent,
	],
	providers: [DialogService],
})
export class AppSidebarModule {}
